export default "/images/marker-icon-2x.png";